import { observer } from 'mobx-react';

import { ShoppingCartItemData } from '../../../app/data/model';
import Accordion from '../../../app/shared/components/Accordion/Accordion';
import ComponentList from '../../../app/shared/components/ComponentList/ComponentList';
import Image from '../../../app/shared/components/Image/Image';
import List from '../../../app/shared/components/List/List';
import { Panel } from '../../../app/shared/components/Panel/Panel';
import { Authorize } from '../../authentication/Authorize';
import { BuyerPolicy } from '../../Policy';
import { ItemUpdateQuantityInput } from '../CartItem/CartItem';
import { CartItemDetails } from '../CartItem/CartItemDetails/CartItemDetails';
import CartItemActions from '../CartItemActions';
import css from './CartItemGroup.css';
import { CartItemGroupState } from './CartItemGroupState';

interface CartItemGroupProps {
  state: CartItemGroupState;
}

export const CartItemGroup = observer(({ state }: CartItemGroupProps) => {
  return (
    <Panel
      className={css.cartItem}
      bodyClassName={css.cartItemBody}
      header={{
        heading: state.item.name,
        headingActionButtons: (
          <CartItemActions items={state.cartItemGroupContextCommands} translation={state.translation.cartItemActions} />
        ),
        headerClassName: css.cartItemHeader,
      }}
    >
      <>
        <Image
          className={css.cartItemBodyImage}
          src={state.item.imageUrl}
          width={80}
          height={140}
          sharpeningFactor={1.5}
          scalingMode="fit"
        />
        <div className={css.cartItemBodyDetails}>
          <CartItemDetails
            code={state.item.modularCode}
            // systemMessage={item.systemMessage}
            listPrice={state.item.listPrice}
            salePrice={state.item.salePrice}
            className={css.cartItemDetails}
            propertyClassNames={{
              propClassName: css.cartItemBodyDetailsProp,
              labelClassName: css.cartItemBodyDetailsLabel,
              valueClassName: css.cartItemBodyDetailsValue,
            }}
            translation={state.translation.cartItemBodyDetails.cartItemDetails}
          />
          <Authorize policy={BuyerPolicy}>
            <ItemUpdateQuantityInput
              quantity={state.item.quantity}
              quantityUpdate={state.quantityUpdate}
              updateQuantityCommand={state.updateQuantityCommand}
              translation={state.translation.cartItemBodyDetails}
            />
          </Authorize>
        </div>
        <ExpandableComponentList className={css.cartItemBodyComponentList} items={state.item.items} />
      </>
    </Panel>
  );
});

interface ComponentListProps {
  items: ShoppingCartItemData[];
  className?: string;
}

const ExpandableComponentList = ({ className, items }: ComponentListProps) => {
  const renderItem = (item: (typeof items)[number]) => (
    <Accordion title={`${item.baseModel.name} (${item.quantity})`}>
      <ComponentList accessories={item.accessories} options={item.options} />
    </Accordion>
  );

  return <List className={className} items={items} itemRenderer={renderItem} />;
};
